// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import * as React from "react";

const ElectricDividerCenter: React.FC<{ width?: number; height?: number }> = ({ height = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1568" height="16" viewBox="0 0 1568 16">
            <path
                fill="none"
                stroke="#cd4a23"
                strokeMiterlimit="10"
                d="M0 8.05h768.255l4.05-7.049 8.1 14 8.1-14 8.1 14 8.1-14 4.05 7h759.238"
            />
        </svg>
    );
};

export default React.memo(ElectricDividerCenter);
